import { zodTransformEnum } from '../../zod/transformEnum';
import { SessionLocation } from '../session/sessionLocation';
import { z } from 'zod';

export const CustomerTicketSeverity = z.enum(['None', 'Low', 'Medium', 'High', 'Critical', 'Unknown']);
export const CustomerTicketStatus = z.enum(['Open', 'InProgress', 'Closed', 'Unknown']);
export const CustomerTicketType = z.enum(['Normal', 'Silent', 'Hidden', 'Unknown']);

export type CustomerTicketSeverity = z.infer<typeof CustomerTicketSeverity>;
export type CustomerTicketStatus = z.infer<typeof CustomerTicketStatus>;
export type CustomerTicketType = z.infer<typeof CustomerTicketType>;

export const CustomerTicket = z.object({
    id: z.string().nullish(),
    category: z.string().nullish(),
    severity: zodTransformEnum(CustomerTicketSeverity.nullish()),
    originSeverity: zodTransformEnum(CustomerTicketSeverity.nullish()),
    sessionGuid: z.string().nullish(),
    storeGuid: z.string().nullish(),
    deviceId: z.string().nullish(),
    message: z.string().nullish(),
    location: z.unknown().nullish(),
    locationDto: SessionLocation.nullish(),
    openedOn: z.coerce.date().nullish(),
    modifiedOn: z.coerce.date().nullish(),
    closedOn: z.coerce.date().nullish(),
    assignedTo: z.unknown().nullish(),
    assignedOn: z.coerce.date().nullish(),
    status: zodTransformEnum(CustomerTicketStatus.nullish()),
    type: zodTransformEnum(CustomerTicketType.nullish()),
    session: z.unknown().nullish(),
    availableImages: z.string().array().nullish(),
    correlationGuids: z.string().array().nullish(),
});
export type CustomerTicket = z.infer<typeof CustomerTicket>;

export const StoreCustomerTicket = CustomerTicket.extend({
    storeGuid: z.string(),
});
export type StoreCustomerTicket = z.infer<typeof StoreCustomerTicket>;
